const { createSlice } = require('@reduxjs/toolkit');
export const storeData = async (key, value) => {
	try {
		const jsonValue = JSON.stringify(value);
		sessionStorage.setItem(`${key}`, jsonValue);
	} catch (e) {
		// saving error
	}
};

export const getData = async (key) => {
	try {
		const jsonValue = sessionStorage.getItem(`${key}`);
		return jsonValue != null ? JSON.parse(jsonValue) : null;
	} catch (e) {
		// error reading value
	}
};
const UiReducer = createSlice({
	name: 'ui',
	initialState: {
		tab: '',
		modal: false,
		agentId: null,
		modalFetch: false,
		modalmarkup: false,
		modalprod: false,
		modalpipe: false,
		cart: [],
		won: [],
		lost: [],
		custom: [],
		modalprodUC: false,
		modalleadCat: false,
		modallead:false,
		modelSubTask:false,
		modelFileUpload:false,
		modelDocumentCategory:false,
		modelMaterialCategory:false,
		modelMaterial:false,
		modelProject:false,
		modelProjectPlan:false,
		modelEmployee:false,
		modelSubcontractor:false,
		modelSubTaskStatus:false,
		modaltask:false,
		upc: null,
		modalUP: false,
		up: null,		
		rowEditData:null,
		departmentEditData:null,
		designationEditData:null,
		companyEditData:null,
		modelUser:false,
		modelUserPassword:false,
	},
	reducers: {
		toggleQAModal(state, action) {
			state.modelQA = action.payload;
		},

		togglePartnerModal(state, action) {
			state.modelPartner = action.payload;
		},

		toggleRewardModal(state, action) {
			state.modelReward = action.payload;
		},
		toggleRewardAllocationModal(state, action) {
			state.modelReward = action.payload;
		},
		toggleReferralModal(state, action) {
			state.modelReferral = action.payload;
		},

		toggleUserModal(state, action) {
			state.modelUser = action.payload;
		},

		toggleUserPasswordResetModal(state, action) {
			state.modelUserPassword = action.payload;
		},
		toggleDocumentCategoryModal(state, action) {
			state.modelDocumentCategory = action.payload;
		},
		toggleMaterialCategoryModal(state, action) {
			state.modelMaterialCategory = action.payload;
		},
		toggleMaterialModal(state, action) {
			state.modelMaterial = action.payload;
		},
		toggleProjectModal(state, action) {
			state.modelProject = action.payload;
		},
		toggleProjectPlanModal(state, action) {
			state.modelProjectPlan = action.payload;
		},
		toggleEmployeeModal(state, action) {
			state.modelEmployee = action.payload;
		},
		toggleSubcontractorModal(state, action) {
			state.modelSubcontractor = action.payload;
		},
		toggleDepartmentModal(state, action) {
			state.modelDepartment = action.payload;
		},
		toggleDesignationModal(state, action) {
			state.modelDesignation = action.payload;
		},
		toggleCompanyModal(state, action) {
			state.modelCompany = action.payload;
		},
		
		toggleFileUploadModal(state, action) {
			state.modelFileUpload = action.payload;
		},
		setTab(state, action) {
			state.tab = action.payload;
		},
		
		setUPC(state, action) {
			state.upc = action.payload;
		},
		setEditData(state, action) {
			state.rowEditData = action.payload;
		},
		setDesignationEditData(state, action) {
			state.designationEditData = action.payload;
		},
		setDepartmentEditData(state, action) {
			state.departmentEditData = action.payload;
		},
		setCompanyEditData(state, action) {
			state.companyEditData = action.payload;
		},

		setRewardAllocationEditData(state, action) {
			state.rewardAllocationEditData = action.payload;
		},
		
		setUP(state, action) {
			state.up = action.payload;
		},
		toggleModal(state, action) {
			state.modal = action.payload;
		},
	
		setID(state, action) {
			state.agentId = action.payload;
		},
		toggleModalFetch(state, action) {
			state.modalFetch = action.payload;
		},
		toggleModalMarkup(state, action) {
			state.modalmarkup = action.payload;
		},		
		
		
	},
});

const { actions } = UiReducer;

export const {
	toggleQAModal,
	togglePartnerModal,
	toggleRewardModal,
	toggleRewardAllocationModal,
	toggleReferralModal,
	toggleUserModal,
	toggleUserPasswordResetModal,
	toggleFileUploadModal,
	toggleDocumentCategoryModal,
	toggleMaterialCategoryModal,
	toggleMaterialModal,
	toggleProjectModal,
	toggleProjectPlanModal,
	toggleEmployeeModal,
	toggleSubcontractorModal,
	toggleDepartmentModal,
	toggleDesignationModal,
	toggleCompanyModal,
	toggleModal,
	setID,
	addCustom,	
	setUPC,
	setUP,	
	setEditData,
	setRewardAllocationEditData,
} = actions;

export default UiReducer;
